module.exports = "/images/ua.svg?8fe8488728e449d8296594b6bb345b86";